import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_STRADE } from '@/service'
const api = {
  logapi: PREFIX_STRADE + 'confirmTest.do'
}
export default {
  // 后台接收并打印出来，不做任何逻辑处理，不记录数据库，专为记录前端关键日志,前端也不关注这个接口是否报错之类的
  async sendLog({ commit }, logStr) {
    try {
      const res = await fetch(`${api.logapi}?param=${logStr}`)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
      return ''
    }
  }
}
